import React from 'react';
import { Modal } from './Modal';
import { Button } from './Button';
import { AlertCircle, Trophy, Target } from 'lucide-react';
interface SaveProgressPromptProps {
  isOpen: boolean;
  onClose: () => void;
  onSignUp: () => void;
  stats: {
    games: number;
    wins: number;
    xp: number;
  };
}
export function SaveProgressPrompt({
  isOpen,
  onClose,
  onSignUp,
  stats
}: SaveProgressPromptProps) {
  return <Modal isOpen={isOpen} onClose={onClose} title="Save Your Progress!" className="max-w-md" data-id="element-687">
      <div className="space-y-6" data-id="element-688">
        {/* Warning */}
        <div className="text-center" data-id="element-689">
          <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-690">
            <AlertCircle className="text-amber-600" size={32} data-id="element-691" />
          </div>
          <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-692">
            Don't Lose Your Progress!
          </h3>
          <p className="text-slate-600" data-id="element-693">
            Create an account to save your stats and continue playing across
            devices
          </p>
        </div>

        {/* Current Stats */}
        <div className="grid grid-cols-3 gap-3" data-id="element-694">
          <div className="bg-blue-50 rounded-xl p-3 text-center" data-id="element-695">
            <Target className="text-blue-600 mx-auto mb-1" size={20} data-id="element-696" />
            <div className="text-2xl font-black text-slate-900" data-id="element-697">
              {stats.games}
            </div>
            <div className="text-xs text-slate-600" data-id="element-698">Games</div>
          </div>
          <div className="bg-emerald-50 rounded-xl p-3 text-center" data-id="element-699">
            <Trophy className="text-emerald-600 mx-auto mb-1" size={20} data-id="element-700" />
            <div className="text-2xl font-black text-slate-900" data-id="element-701">
              {stats.wins}
            </div>
            <div className="text-xs text-slate-600" data-id="element-702">Wins</div>
          </div>
          <div className="bg-violet-50 rounded-xl p-3 text-center" data-id="element-703">
            <div className="text-2xl mb-1" data-id="element-704">⚡</div>
            <div className="text-2xl font-black text-slate-900" data-id="element-705">{stats.xp}</div>
            <div className="text-xs text-slate-600" data-id="element-706">XP</div>
          </div>
        </div>

        {/* Actions */}
        <div className="space-y-3" data-id="element-707">
          <Button fullWidth size="xl" onClick={onSignUp} data-id="element-708">
            Create Account & Save
          </Button>
          <Button fullWidth variant="outline" onClick={onClose} data-id="element-709">
            Continue Without Saving
          </Button>
        </div>

        <p className="text-xs text-center text-slate-500" data-id="element-710">
          Your progress will be lost if you don't create an account
        </p>
      </div>
    </Modal>;
}